import React, { useMemo, useState } from "react";
import styled from "styled-components";
import { useStudyPlan } from "../../../../app/contexts/study.context";
import { CountryHeader } from "../../../../app/components";
import PrimaryButton from "../../../../app/components/buttons/primary";
import CountryInputs from "./country.inputs";
import CountryGlobalMilestones from "./country.global.milestones";
import CountryActivationProfiles from "./country.activation.profiles";
import CountryEnrollmentSeasonalVariations from "./country.enrollment.seasonal.variations";
import SequentialCohortSetupTable from "../sequential.cohort.table";
import SiteFatigue from "./site.fatigue";
import SeparateContainer from "../../../../app/components/separate.Container";
import ViewSiteListModal from "../../../../study.plan.actuals/controls/ViewSiteListModal";

const CountryPanel = ({ value, id, country }) => {
  const { studyPlan, updatePlan } = useStudyPlan();
  const isRemodel = studyPlan?.studyPlanTypeDetail?.includes("Remodel");
  const { cohortType, studyPlanTypeDetail } = studyPlan;
  const [remodelViewOpen, setRemodelViewOpen] = useState(false);

  const sequentialCohort = useMemo(
    () => cohortType === 2 && studyPlanTypeDetail === "Cohort (D)",
    [cohortType, studyPlanTypeDetail],
  );

  const handleDelete = () => {
    const { countries } = studyPlan;

    const index = countries
      .map((country) => country.countryId)
      .indexOf(country.countryId);

    countries.splice(index, 1);

    updatePlan("countries", countries);
  };

  const siteGroup = country.siteGroups[0];

  return (
    <div
      role="tabpanel"
      hidden={value !== id}
      id={`scrollable-auto-tabpanel-${id}`}
    >
      {value === id && (
        <Container>
          <ButtonContainer>
            {isRemodel && (<PrimaryButton onClick={() => setRemodelViewOpen(true)}>
              VIEW SITE LIST
            </PrimaryButton>)}
          </ButtonContainer>
          <SeparateContainer>
            <CountryHeader
              title={`${country.countryName} - ${country.countryCodeISO3}`}
              onClick={handleDelete}
              countryId={country.countryId}
              studyPlanType={studyPlan.studyPlanType}
              siteGroup={siteGroup}
              hasDelete={false}
              hasEdit={false}
              tab={value}
            />
            <CountryInputs
              country={country}
              siteGroup={siteGroup}
              tab={value}
            />
          </SeparateContainer>
          <br />
          <CountryGlobalMilestones
            country={country}
            siteGroup={siteGroup}
            tab={value}
          />
          <br />
          <CountryActivationProfiles
            country={country}
            siteGroup={siteGroup}
            tab={value}
          />
          {sequentialCohort && (
            <>
              <br />
              <SequentialCohortSetupTable tab={value} />
            </>
          )}
          <br />
          <CountryEnrollmentSeasonalVariations
            tab={value}
            country={country}
            siteGroup={siteGroup}
          />
          <br />
          <SiteFatigue
            country={country}
            siteGroup={siteGroup}
            tab={value}
          />
          <ViewSiteListModal
            remodelViewOpen={remodelViewOpen}
            setRemodelViewOpen={setRemodelViewOpen}
            country={country}
          />
        </Container>
      )}
    </div>
  );
};

export default CountryPanel;

const Container = styled.div`
  padding: 1em 0;
  display: grid;
  gap: 1em;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;
